import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ac5b5cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ac5b5cb&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=6ac5b5cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5b5cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac5b5cb')) {
      api.createRecord('6ac5b5cb', component.options)
    } else {
      api.reload('6ac5b5cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ac5b5cb&scoped=true", function () {
      api.rerender('6ac5b5cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/bidFileCheck/checkList/index.vue"
export default component.exports